import React from 'react';
import { FIELD_TYPES } from '../../../sdk/config';
import { TextInputFieldWUT } from '../../../ui/text-input-field/text-input-field-wut';
export const TextInputWUT = (props)=>{
    const fieldType = FIELD_TYPES.TEXT_INPUT;
    return /*#__PURE__*/ React.createElement(TextInputFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=text-input-wut.js.map